module.exports = __webpack_public_path__ + "static/media/expo.096b7308.png";